import React, {useState} from "react";
import {validation} from "../../../helpers/ValidationHelper";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";

function validateHostValue(value) {
    return !!value.length;
}

function validatePortValue(value) {
    return value > 0;
}

export default function DeviceEthernetTransport({settings, onChange, onValidationSuccess, onValidationError}) {
    const [validationErrors, setValidationErrors] = useState({});

    function handleSetValidationErrors(value) {
        setValidationErrors(value);

        Object.keys(value).length
            ? onValidationSuccess()
            : onValidationError();
    }

    function handleHostChange(event) {
        handleSetValidationErrors(
            validation(
                event.target.value,
                "host",
                validationErrors,
                validateHostValue
            )
        );

        onChange({"host": event.target.value});
    }

    function handlePortChange(event) {
        handleSetValidationErrors(
            validation(
                event.target.value,
                "port",
                validationErrors,
                validatePortValue
            )
        );

        onChange({"port": event.target.value});
    }

    return (
        <Grid container spacing={2} direction={"column"} justify={"center"} alignItems={"center"}>
            <Grid item xs={12}>
                <TextField
                    id="ethernet-host"
                    label="Host"
                    fullWidth
                    value={settings.host}
                    error={validationErrors["host"]}
                    inputProps={{
                        style: {textAlign: "center"}
                    }}
                    onChange={handleHostChange}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="ethernet-port"
                    type={"number"}
                    label={"Port"}
                    fullWidth
                    value={settings.port}
                    error={validationErrors["port"]}
                    inputProps={{
                        style: {textAlign: "center"}
                    }}
                    onChange={handlePortChange}
                />
            </Grid>
        </Grid>
    );
}